import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import TagsRow from './../tagsRow/TagsRow';
import getData from '../../services/GetData';

const MomentTopics = () => {
  const [topics, setTopics] = useState();
  useEffect(() => {
    const fetchData = () => {
      const url = `${window.env.RAZZLE_ENDPOINT_NOTI_API}/api/News/GetMomentTopics`;
      getData({url}).then(resp => setTopics(resp.data));
    };

    fetchData();
  }, []);

  return (
    <MomentTopicsSection
      className="container d-flex flex-wrap"
      hasTopics={topics}>
      {!topics ? null : (
        <div className="d-flex align-items-center col-12 px-0">
          <TagsRow data={topics}/>
        </div>
      )}
    </MomentTopicsSection> 
  );
};

export default MomentTopics;

const MomentTopicsSection = styled.section`
  height: 40px;
  margin: 10px 0;
  overflow-x: hidden;
  z-index: 8;
`;